import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Rd from '../views/Rd.vue'
import Solutions from '../views/Solutions.vue'
import SolutionDetail from '../views/SolutionDetail.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Contact from '../views/Contact.vue'
import Jobs from '../views/Jobs.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: About },
  { path: '/rd', name: 'Rd', component: Rd },
  { path: '/solutions', name: 'Solutions', component: Solutions },
  { path: '/solutions/:id', name: 'SolutionDetail', component: SolutionDetail },
  { path: '/news', name: 'News', component: News },
  { path: '/news/:id', name: 'NewsDetail', component: NewsDetail },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/jobs', name: 'Jobs', component: Jobs }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 全局路由守卫：路由跳转完成后执行
router.afterEach((to) => {
  // 获取路由hash参数（如 /page#targetAnchor 中的 targetAnchor）
  const anchor = to.hash.slice(1); // 去除#号，得到锚点id
  if (anchor) {
    // 延迟执行：确保页面元素已渲染完成
    setTimeout(() => {
      const targetElement = document.getElementById(anchor);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }, 100);
  }
});

export default router
